import { render, staticRenderFns } from "./AddNewSpeaker.vue?vue&type=template&id=93c0255e"
import script from "./AddNewSpeaker.vue?vue&type=script&lang=js"
export * from "./AddNewSpeaker.vue?vue&type=script&lang=js"
import style0 from "./AddNewSpeaker.vue?vue&type=style&index=0&id=93c0255e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports